export default __webpack_public_path__ + "static/media/slide3.cf675cdf.png";